import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTE_PATHS } from '../../utils/route-paths.const';

/**
 * Guards /investment-blocked.
 * - Allows entry only when `state: { canInvest: false }` is present (set by the
 *   investment component after the eligibility API returns canInvest=false).
 * - If the user is already inside the app (eligible) and somehow triggers a
 *   navigation here, they stay on their current URL.
 * - A cold direct-URL visit with no prior navigation falls back to HOME.
 */
export const investmentBlockedGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const nav = router.currentNavigation();

  if (nav?.extras.state?.['canInvest'] === false) return true;

  const hasPriorNav = nav?.previousNavigation != null;
  if (hasPriorNav) {
    router.navigateByUrl(router.url, {
      replaceUrl: true,
      state: { bypassGuard: true },
    });
  } else {
    router.navigate([ROUTE_PATHS.HOME], {
      replaceUrl: true,
      state: { bypassGuard: true },
    });
  }
  return false;
};
